export enum ELevelTypes {
    Default = 0,
    Group = 1,
    Campaign = 2,
    Company = 3,
    Affiliate = 4
}